export enum AppRoutes {
  HOME = '/',
  NOT_FOUND = '*',
  LOGIN = '/login',
  FORGOT_PASSWORD = '/forgot-password',
  RESET_PASSWORD = '/reset-password',
  WAREHOUSES = '/warehouses',
  CITIES = '/cities',
  USERS = '/users',
  CONTRACTS = '/contracts',
  PRICE_RAISE = '/price-raise',
  PAYMENTS = '/payments',
  NOTES = '/notes',
  TASKS = '/tasks',
  GENERAL = '/general',
  BOOKING = '/booking',
  MY_BOXES = '/my-boxes',
  GLOBAL_SETTINGS = '/global-settings',
  CHECKOUT = '/checkout',
  PAYMENT_SUCCESS = '/payment-success',
  PAYMENT_FAILED = '/payment-failed',
  PAYMENT_RETURN = '/payment-return',
  BOXES = '/boxes',
  INVOICES = '/billing-documents/invoices',
  CREDIT_NOTES = '/billing-documents/credit-notes',
  INSURANCE = '/billing-documents/insurance',
  RESERVATIONS = '/reservations',
  ADMIN_PANEL = '/admin-panel',
  LATE_CHARGE_SETTINGS = '/late-charge-settings',
  PROFILE = '/profile',
  BILLING_DOCUMENTS = '/billing-documents',
  INSURANCE_SETTINGS = '/insurance-settings',
  DEPOSITS = '/deposits',
  NO_RESULT = '/no-result',
  STATISTICS = '/statistics',
  BOXES_OCCUPANCY = '/statistics/boxes-occupancy',
  INCOME_STATISTICS = '/statistics/income',
  ARRIVALS_STATISTICS = '/statistics/arrivals',
  PAYMENTS_STATISTICS = '/statistics/payments',
  BOXES_REVENUE = '/statistics/boxes-revenue',
  DISCOUNTS = '/discounts',
  HISTORY = '/history',
  WAITING_LIST = '/waiting-list',
  SELF_ISSUED_RECEIPTS = '/self-issued-receipts',
}
